'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = 'M492.3 153.2c-32.2-56.4-84-100.1-146.1-121.9 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58zm-472.6 0C7.3 137.2 0 117.1 0 95.2 0 42.6 42.6 0 95.2 0 123.2 0 148.4 12.1 165.8 31.3 103.7 53.1 51.9 96.9 19.7 153.2zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6C96.3 493 77 512.3 64 525.3L18.7 480C31.7 467 51 447.7 76.6 422.2 48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l57.8 57.8-45.3 45.3-57.8-57.8zM232 160l0 137.9 7 7 72 72 33.9-33.9-65-65 0-118.1-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;